import React from 'react'
import "./Civil.css"
import Slider from '../../Home/Slider/Slider'
import civilimage1 from"../../Home/images/Civil-engineers.jpg"
import civilimage2 from"../Departmentimage/IMG_1322 (FILEminimizer).JPG"
const Civil = () => {
  return (
    <div className='main-container-civil'>  
       {/* <Slider></Slider> */}
       {/* <img src={civilimage1} className='civilimage2' /> */}
       <div className='container-civil'>
       <div data-aos="fade-down"
         data-aos-easing="linear"
        data-aos-duration="1500">

        <h1>Civil Engineering</h1> <hr />
        </div>
        <div data-aos="fade-up"
     data-aos-easing="linear"
     data-aos-duration="1500">
        <div className='container-civil1'>
      

            <div className='civil1'>
            <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">

              <p>The vision of the department is to create high quality civil 
                engineers who can uplift the quality of life by providing the 
                sustainable quality environment to the society through 
                creation of excellent infrastructure and public health facilities 
                and adapt quickly to the rapid technological changes without 
                sacrificing their ethical and moral values.
              </p> <br />
              <p>The mission of the department is to provide the best teaching 
                  learning environment and to ensure sufficient technological 
                  and software exposure to the students by providing them high 
                  quality modern civil engineering laboratories. The department 
                  ensures their lifelong learning by effective counselling it helps 
                  them to achieve their career goals under guidance of highly 
                  qualified faculty members.                 
              </p> <br />
              <p>
              The department of civil engineering make every effort to 
              produce the best quality civil engineers who can perform 
              across the world. The department is equipped with all the 
              modern civil engineering laboratories which enable the 
              students to correlate their theoretical knowledge with 
              practical experience. The department focuses on creative and 
              innovative classroom teaching, team work, interpersonal 
              communication skills, and research activities. The department 
              modern methodologies like interactive lectures, guided 
              case studies, literature surveys and project work.
              </p> <br />
              <p>
              The department of civil engineering has well qualified and 
              experienced faculty that continues to strive loftier by exploring 
              new frontiers of knowledge, imparting the latest technical 
              knowledge to the students. The faculty members are actively 
              involved with students to guide, motivate and train them in 
              achieving their professional goals. The Department organizes 
              free of cost in-house summer training for civil engineering 
              students to impart industry relevant building designing skills.
              </p> <br />
              </div>
            </div>
            <div className='civil-image'>
            <div data-aos="fade-left"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
              <ul>
                <div className='civil4'>
              <div className='civil2'>
                <li> Soil & Foundation Lab</li>
                <li>Waste & Water Supply Lab</li>
                <li> Concrete Technology Lab</li>
                <li>Survey Lab</li> <br /> </div>
                <div className='civil3'>
                <li>Fluid Mechanical Lab
                </li>
                <li>Strength of Material Lab</li>
                <li>Highway Lab</li>
                <li>Auto Cad Lab</li>
                </div>
                </div>
              </ul>
              <div data-aos="flip-left"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="3000">
              <img src={civilimage2} className='civil-image1'/>
              </div>
            </div>
            </div>
        </div>    
        </div>           
       </div>

    </div>
  )
}

export default Civil
